// extracted by mini-css-extract-plugin
module.exports = {"amenity":"g2RqjZ"};